import { Box, styled } from '@mui/material'

export const StyledStatCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2.5, 1),
  borderLeft: `solid ${theme.palette.primary.main}`,
  flex: 1,
  borderWidth: 8,
  [theme.breakpoints.up('md')]: {
    borderWidth: 4,
    padding: theme.spacing(2.5, 2),
    width: '136px',
  },
}))
